export class SearchCriteria {
    searchTerm: string = "";
    pageNo: number = 1;
    pageSize: number = 50;
}
